import { DEFAULT_LANG, STATUS_NUM } from 'common/constants';
import { isBrowser } from 'common/constants/config';

import { KEY_LONG_PREVIEW, KEY_PREVIEW } from '../constants';

class Store {
  static mInstance;

  static getInstance() {
    if (!Store.mInstance) {
      Store.mInstance = new Store();
    }
    return Store.mInstance;
  }

  lang = DEFAULT_LANG; // en
  preview = STATUS_NUM.FALSE_NUM; // 0

  setStore(key, value) {
    this[key] = value;
  }
  getStore(key) {
    return this[key];
  }

  setLang(lang) {
    this.lang = lang;
  }
  getLang() {
    return this.lang;
  }

  setIsPreview() {
    this.preview = STATUS_NUM.TRUE_NUM;
  }
  setIsNotPreview() {
    this.preview = STATUS_NUM.FALSE_NUM;
  }
  getPreview() {
    if (isBrowser) {
      const url = window.location.href;
      if (url.includes(KEY_LONG_PREVIEW) || url.includes(KEY_PREVIEW)) {
        return STATUS_NUM.TRUE_NUM;
      }
    }
    return this.preview;
  }
}

export default Store.getInstance();
